import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

function Map() {
  return (
    <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
      <CardContent>
        <Typography variant="h6" mb={2}>
          Find Us Here
        </Typography>
        <Box sx={{ width: "100%", height: 350, borderRadius: 2, overflow: "hidden" }}>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m13!1m8!1m3!1d1014116.3937592254!2d79.864282!3d6.843501000000001!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNsKwNTAnMzYuNiJOIDc5wrA1MSc1MS40IkU!5e0!3m2!1sen!2sus!4v1755675198300!5m2!1sen!2sus"
            width="100%"
            height="450"
            allowfullscreen=""
            loading="lazy"
          ></iframe>
        </Box>
      </CardContent>
    </Card>
  );
}

export default Map;
